// Reference shown in the formula editor. `insert` is what clicking adds.
export const FUNCTION_GROUPS = [
  {
    title: "Totals across rows",
    items: [
      { name: "SUM", insert: "SUM(col.amount)", desc: "Total of a column or expression over all rows.", ex: "SUM(col.qty * col.rate)  ·  SUM(tax.taxable)" },
      { name: "COUNT", insert: "COUNT()", desc: "Number of rows (or non-blank values).", ex: 'COUNT()  ·  COUNT("payments")' },
      { name: "AVG", insert: "AVG(col.rate)", desc: "Average over all rows.", ex: "AVG(item_unit_price)" },
      { name: "MIN / MAX", insert: "MAX(col.amount)", desc: "Smallest / largest value. With 2+ arguments compares those values.", ex: "MAX(col.amount)  ·  MAX(0, a - b)" },
      { name: "SUMIF", insert: "SUMIF(item_gst = 12, col.amount)", desc: "Total only for rows matching a condition.", ex: "SUMIF(item_gst = 5, col.taxable)" },
      { name: "COUNTIF", insert: "COUNTIF(item_free_quantity > 0)", desc: "Rows matching a condition.", ex: 'COUNTIF(item_schedule = "H")' },
      { name: "JOIN", insert: 'JOIN(payments.payment_mode_name, ", ")', desc: "Joins values of all rows into one text.", ex: 'JOIN(items.item_batch_number, " / ")' },
      { name: "FIRST / LAST", insert: "FIRST(item_name)", desc: "Value from the first / last row.", ex: "LAST(col.running_total)" },
    ],
  },
  {
    title: "Between rows (inside a table column)",
    items: [
      { name: "PREV", insert: "PREV(col.amount, 0)", desc: "Value from the previous row. Second argument is used on the first row.", ex: "PREV(col.balance, 0) + col.amount  (running balance)" },
      { name: "NEXT", insert: "NEXT(col.amount, 0)", desc: "Value from the next row.", ex: "col.amount - NEXT(col.amount, 0)" },
      { name: "ROW", insert: "ROW(1, col.amount)", desc: "Value from a specific row number (negative counts from the end). Works anywhere.", ex: "ROW(2, col.amount) - ROW(1, col.amount)  ·  ROW(-1, item_name)" },
      { name: "RUNSUM", insert: "RUNSUM(col.amount)", desc: "Running total down to the current row.", ex: "RUNSUM(col.qty)" },
      { name: "SNO", insert: "SNO()", desc: "Serial number of the current row (1, 2, 3...).", ex: "SNO()" },
    ],
  },
  {
    title: "Logic",
    items: [
      { name: "IF", insert: 'IF(condition, "yes", "no")', desc: "Choose between two values.", ex: 'IF(gst_type = "Intra", col.tax / 2, 0)' },
      { name: "IFS", insert: 'IFS(a > 1000, "High", a > 100, "Mid", "Low")', desc: "First value whose condition is true; last argument is the fallback.", ex: "" },
      { name: "COALESCE", insert: 'COALESCE(field, "-")', desc: "First value that is not blank.", ex: "COALESCE(cmr_name, cmr_first_name)" },
      { name: "AND / OR / NOT", insert: "a > 0 AND b > 0", desc: "Combine conditions (also usable as AND(x, y)).", ex: "qty > 0 OR free > 0" },
      { name: "ISBLANK", insert: "ISBLANK(field)", desc: "True when a value is empty.", ex: "" },
    ],
  },
  {
    title: "Numbers",
    items: [
      { name: "ROUND", insert: "ROUND(value, 2)", desc: "Round to N decimals (ROUNDUP / ROUNDDOWN also available).", ex: "ROUND(col.qty * col.rate, 2)" },
      { name: "ABS / INT / MOD", insert: "ABS(value)", desc: "Absolute value, whole part, remainder.", ex: "MOD(SNO(), 2)" },
      { name: "PERCENT", insert: "PERCENT(part, whole)", desc: "part as a % of whole.", ex: "PERCENT(col.amount, SUM(col.amount))" },
      { name: "WORDS", insert: "WORDS(order.sot_total_amount)", desc: 'Amount in words (Indian). Second argument "after" or "plain" changes the wording.', ex: 'WORDS(var.grand_total, "after")' },
      { name: "FORMAT", insert: 'FORMAT(value, "money")', desc: "Format a value: money, currency, fixed:2, percent, date:DD/MM/YYYY, upper, words...", ex: 'FORMAT(payment_amount, "money")' },
    ],
  },
  {
    title: "Text & dates",
    items: [
      { name: "&", insert: ' & " " & ', desc: "Joins text.", ex: 'cmr_first_name & " " & cmr_last_name' },
      { name: "UPPER / LOWER / PROPER", insert: "UPPER(value)", desc: "Change letter case.", ex: "" },
      { name: "LEFT / RIGHT / MID", insert: "LEFT(value, 10)", desc: "Part of a text.", ex: "" },
      { name: "REPLACE", insert: 'REPLACE(value, "-", "/")', desc: "Replace every occurrence.", ex: "" },
      { name: "DATE", insert: 'DATE(created_date, "DD MMM YYYY")', desc: "Format a date. Tokens: DD MM MMM YYYY YY hh mm A.", ex: 'DATE(item_exp_date, "MM/YY")' },
      { name: "TODAY / NOW", insert: 'TODAY("DD/MM/YYYY")', desc: "Current date / date-time.", ex: "" },
      { name: "ADDDAYS / DAYS", insert: "ADDDAYS(created_date, 30)", desc: "Shift a date / days between two dates.", ex: "DAYS(due_date, created_date)" },
    ],
  },
];

export const ALL_FUNCTIONS = [
  "SUM", "COUNT", "AVG", "MIN", "MAX", "SUMIF", "COUNTIF", "AVGIF", "MINIF", "MAXIF", "JOIN", "DISTINCT", "FIRST", "LAST",
  "PREV", "NEXT", "ROW", "RUNSUM", "SNO", "ROWCOUNT", "IF", "IFS", "SWITCH", "COALESCE", "AND", "OR", "NOT", "ISBLANK",
  "ISNUMBER", "ROUND", "ROUNDUP", "ROUNDDOWN", "FLOOR", "CEIL", "INT", "ABS", "MOD", "POWER", "SQRT", "PERCENT", "NUM",
  "FORMAT", "TEXT", "WORDS", "CONCAT", "UPPER", "LOWER", "PROPER", "TRIM", "LEN", "LEFT", "RIGHT", "MID", "REPLACE",
  "CONTAINS", "STARTSWITH", "REPEAT", "DATE", "TODAY", "NOW", "ADDDAYS", "DAYS",
];
